import React from 'react'

const MODAL_CLASS_NAME = 'modal'

export default function withOutsideClickHandler(WrappedComponent) {
  return class extends React.Component {

    componentDidMount() {
      document.addEventListener('mousedown', this.handleOutSideClick, false)
      document.addEventListener('keypress', this.handleOutSideClick, false)
    }

    componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleOutSideClick, false)
      document.removeEventListener('keypress', this.handleOutSideClick, false)
    }

    handleOutSideClick = (e) => {
      if (
        this.targetIsContainer(e.target) ||
        this.containerContainsTarget(e.target) ||
        this.containerIsTargetAncestor(e)
      ) {
        return
      }
      else {
        this.onOutsideClick && this.onOutsideClick(e)
      }
    }

    setOutsideClickHandler = (handler) => {
      this.onOutsideClick = handler
    }

    provideContainer = ref => this.wrappedContainer = ref

    targetIsContainer = (target) => target === this.wrappedContainer
    containerContainsTarget = (target) => this.wrappedContainer.contains(target)
    containerIsTargetAncestor = (e) => e.path && e.path.includes(this.wrappedContainer)

    render() {
      return (
        <WrappedComponent
          {...this.props}
          provideContainer={this.provideContainer}
          provideOutsideClickHandler={this.setOutsideClickHandler} />
        )
    }
  }
}
